import { fetchData } from 'services/http/http';
import portalSchema from 'support/types/schema-portal';

type DocuParseCredentials = portalSchema.components['schemas']['DocuParseCredentials'];

let credentials: Promise<DocuParseCredentials> | undefined;

export const getDocuParseCredentials = (): Promise<DocuParseCredentials> => {
  credentials ??= fetchData<DocuParseCredentials>('/v1/docuparse/credentials')
    .then(({ data }) => data)
    .catch((error: unknown) => {
      credentials = undefined;
      throw error;
    });

  return credentials;
};
